// Display-only formatting for the blueprint Governance tab. The rows keep the
// raw API values because toPayloadItem saves them back as they are.

const CALCULATION_LABELS: Record<string, string> = {
  percent_of_total: "Percent of Total Hours",
  fixed_hours: "Fixed Hours",
};

export const calculationLabel = (calculationType: string): string =>
  CALCULATION_LABELS[calculationType] ?? calculationType;

// The API stores a percent as a fraction (0.2 = 20%), sometimes as a string.
export const rateLabel = (calculationType: string, rate: unknown): string => {
  if (rate === null || rate === undefined || rate === "") return "";
  if (calculationType !== "percent_of_total") return String(rate);
  const fraction = Number(rate);
  if (!Number.isFinite(fraction)) return String(rate);
  return `${Number((fraction * 100).toFixed(2))}%`;
};
